import * as React from 'react';
import * as styles from './LeaderWrapper.css';

interface ILeaderWrapperProps {
  children: React.ReactNode;
}

export const LeaderWrapper = ({ children }: ILeaderWrapperProps) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
